import { h } from 'preact';
import * as BaseComp from 'components/bolt/showtimes/dateScroller.js';
import Store from 'store/store';
// import s from 'components/bolt/showtimes/dateScroller.sss';

export default class DateScroller extends BaseComp.default {

	dateClicked(date) {
		Store.emit('CUSTOM_EVENT', { action: 'dateScrollerClick', category: 'showtimes', label: date });
		return super.dateClicked(date);
	}

}
